import { render } from "./PageReviews.vue?vue&type=template&id=a480cb7a&scoped=true"
import script from "./PageReviews.vue?vue&type=script&lang=js"
export * from "./PageReviews.vue?vue&type=script&lang=js"

import "./PageReviews.vue?vue&type=style&index=0&id=a480cb7a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a480cb7a"]])

export default __exports__